import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceListings from "./sections/ServiceListings";
import WhyChooseUs from "./sections/WhyChooseUs";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceListings />
      <WhyChooseUs />
      <Footer />
    </div>;
}